import React, { useEffect, useState } from 'react'
import { useListVals } from 'react-firebase-hooks/database'
import { useHistory } from 'react-router-dom'
import ReactTimeAgo from 'react-time-ago'
import styled from 'styled-components'
import { NotificationDb } from '../../firebaseConfig'
import { fixedAssets } from 'src/containers/PreCache'
import { Loader } from 'src/components/shared/Loader'
import MobileHeader from 'src/components/MobileHeader'
import { IoClose } from 'react-icons/io5'

const MobileNotifications = () => {
  const [values, loading, error] = useListVals(NotificationDb)
  const history = useHistory()
  const [notification, setNotification] = useState(null)

  const goBack = () => {
    history.goBack()
  }

  const refreshPage = () => {
    window.location.reload()
  }

  const handleRedirect = (url) => {
    history.push(url)
  }

  useEffect(() => {
    const newItems = values.length - localStorage.getItem('IA_notifications')
    let updated = values
      .sort((a, b) => new Date(b.datetime) - new Date(a.datetime))
      .map((item, index) => {
        return {
          ...item,
          read: index < newItems ? false : true,
        }
      })
    setNotification(updated)
    if (values.length > localStorage.getItem('IA_notifications')) {
      localStorage.setItem('IA_notifications', values.length)
    }
  }, [loading, values])

  return (
    <Page>
      <main className="">
        {/* <div>
          <h4 className="title text-center">Notifications</h4>
          <button>

          </button>
        </div> */}
        <div className="d-md-none custom-header d-flex flex-row justify-content-center align-items-center py-3">
          <p className="title text-center m-0">Notifications</p>
          <div className="px-1" onClick={goBack} style={{ cursor: 'pointer', color: '#0c4484' }}>
            <IoClose size={30} />
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : error ? (
          <button className="error-button" onClick={refreshPage}>Connection failed. Click here to refresh.</button>
        ) : (
          notification.map((item, index) => {
            return (
              <div className={`item-wrapper ${!item.read && 'unread'}`} key={index}>
                <div className="item-content">
                  <p className="item-content-label">{item.message}</p>
                  <p className="item-content-time">{item.datetime && <ReactTimeAgo date={item.datetime} />}</p>
                </div>
                {item.url && (
                  <button type="button" onClick={() => handleRedirect(item.url)} className="btn c-button">
                    Enter
                  </button>
                )}
              </div>
            )
          })
        )}
      </main>
    </Page>
  )
}

const Page = styled.div`
  background: url(${fixedAssets.mobileBg});
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;

  height: calc(100% - 50px);
  width: 100vw;
  overflow-y: scroll;
  position: absolute;

  .title {
    font-size: 1.5rem;
    font-weight: 700;
    padding-bottom: 8px;
    color: #0c4484;
    flex: 1;
  }

  .custom-header {
    border-bottom: 1px solid rgba(30, 37, 58, 0.2);
  }

  main {
    width: 98%;
    margin: auto;
    background: #fff;
    height: calc(100% - 60px);
    border-radius: 10px;
    padding: 1rem;
  }
  /* Canonical button style — matches the login page submit button
     (src/pages/LoginPage/LoginPage.tsx '.submit-btn') for visual
     consistency across the app. Scoped to this page only (rather than
     overriding the shared global '.c-button' class in src/index.css)
     so the many other unrelated '.c-button' usages elsewhere in the
     app are left untouched. */
  .c-button {
    font-size: 14px;
    font-weight: 700;
    width: 100%;
    margin-block: 1rem;
    background: var(--Gold-Gradient-01);
    color: #fff !important;
    border-radius: 10px;
    box-shadow: 0px 4px 6.15px rgba(0, 0, 0, 0.21);
  }

  .error-button {
    padding: 5px 10px;
    border: 0;
    border-radius: 10px;
    background: var(--Gold-Gradient-01);
    box-shadow: 0 4px 6.15px rgba(0, 0, 0, 0.21);
    color: #fff;
    font-family: 'Din', 'DIN', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
  }
  .time-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 5px;

    p {
      margin-bottom: 0px;
    }
  }
  .unread {
    background-color: rgba(209, 219, 226, 0.95);
  }

  .time-label {
    font-size: 13px;
    font-weight: bold;
    font-style: italic;
  }

  .time-clear {
    font-size: 11px;
  }

  .item-wrapper {
    width: 100%;
    padding: 15px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #116089;
    color: #fff;
    border-bottom: solid 1px #0c4a6e;
  }

  .item-content {
    width: 100%;
    margin-left: 5px;
    margin-bottom: 0;
  }

  .item-content-label {
    font-size: 12px;
    margin-bottom: 5px;
  }

  .item-content-time {
    font-size: 10px;
    margin-bottom: 0;
  }

  .item-button {
    margin-left: 10px;
    width: 70px;
    padding: 4px 0;
    background: var(--Gold-Gradient-01);
    box-shadow: 0 4px 6.15px rgba(0, 0, 0, 0.21);
    color: #fff;
    font-size: 11px;
    border: none;
    border-radius: 10px;
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      width: 540px;
      margin: auto;
    }
  }
`

export default MobileNotifications
